import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export default {
	data() {
		return {
			asyncDataStatus_isReady: false
		};
	},
	methods: {
		asyncDataStatus_restart() {
			NProgress.start();
			this.asyncDataStatus_isReady = false;
		},
		asyncDataStatus_done() {
			NProgress.done();
			this.asyncDataStatus_isReady = true;
			this.$emit("ready");
		}
	},
	created() {
		NProgress.start();
	}
};
